export default "__VITE_ASSET__CSw8dK9w__"